import React from "react"
import { useTranslation } from 'react-i18next'
import { ReactComponent as StickersIcon } from "../../icon/edit-stickers.svg"
import { ReactComponent as BackgroundsIcon } from "../../icon/edit-background-replacement.svg"
import { ReactComponent as OverlaysIcon } from "../../icon/edit-overlays.svg"
import { ReactComponent as AiEffectIcon } from "../../icon/edit-ai-effect.svg"
import Theme from "../../library/Theme"

interface EditTabProps {
  theme: Theme
  tools: string[]
  selectedIndex: number
  onSelect: (index: number) => void
}

export default function EditTabs({ theme, selectedIndex, tools, onSelect }: EditTabProps) {
  const { t } = useTranslation()

  let inactiveTabStyleIndexMap = [0, 0, 0]
  if (selectedIndex === 0) {
    inactiveTabStyleIndexMap = [0, 0, 1]
  }
  if (selectedIndex === 1) {
    inactiveTabStyleIndexMap = [1, 0, 1]
  }
  if (selectedIndex === 2) {
    inactiveTabStyleIndexMap = [1, 0, 0]
  }

  let tabSizeClassName = tools.length === 3 ? "smallTab" : "mediumTab"

  return (
    <nav id="editTabs">
      {tools.map((tool, index) => (
        <button
          key={tool}
          className={tabSizeClassName + " " + (index === selectedIndex ? "active" : "inactive")}
          style={index === selectedIndex ? theme.toolbarStyle : theme.inactiveTabStyles[inactiveTabStyleIndexMap[index]]}
          onClick={() => onSelect(index)}
        >
          {tool === "stickers" &&
            <>
              <StickersIcon style={theme.svgStyleAlternate} />
              <span className="tabTitle" style={theme.textStyle}>{t("edit.stickers")}</span>
            </>
          }
          {tool === "backgrounds" &&
            <>
              <BackgroundsIcon style={theme.svgStyleAlternate} />
              <span className="tabTitle" style={theme.textStyle}>{t("edit.background")}</span>
            </>
          }
          {tool === "overlays" &&
            <>
              <OverlaysIcon style={theme.svgStyleAlternate} />
              <span className="tabTitle" style={theme.textStyle}>{t("edit.overlay")}</span>
            </>
          }
          {tool === "ai_effect" &&
            <>
              <AiEffectIcon style={theme.svgStyleAlternate} />
              <span className="tabTitle" style={theme.textStyle}>{t("edit.aiEffect.tab")}</span>
            </>
          }
        </button>
      ))}
    </nav>
  )
}